export let RequestAccountantAccess;

(function (RequestAccountantAccess) {
  RequestAccountantAccess["None"] = "none";
  RequestAccountantAccess["Mandatory"] = "mandatory";
  RequestAccountantAccess["Optional"] = "optional";
})(RequestAccountantAccess || (RequestAccountantAccess = {}));